// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ec-typing {
	0% {
		transform: translateY(0);
		opacity: 0.35;
	}
	50% {
		transform: translateY(-6px);
		opacity: 1;
	}
	100% {
		transform: translateY(0);
		opacity: 0.35;
	}
}

.typing-dot {
	background: #7351fd;
	opacity: 0.35;
	animation: ec-typing 0.9s infinite;
}  

.ai-search-btn {
	border: 2px solid transparent;
	background:
    linear-gradient(#fff, #fff) padding-box,
    linear-gradient(
      96.62deg,
      #A451FD 4.25%,
      #2977D1 31.45%,
      #FE0098 100.67%
    ) border-box;
}

.easycommerce-ask-ai-generate-text p,
.easycommerce-ask-ai-generate-text h3 {
	padding-bottom: 15px;
}

.easycommerce-ask-ai-generate-text div,
.easycommerce-ask-ai-generate-text p {
	font-size: 14px;
	line-height: 24px;
}

.easycommerce-ask-ai-generate-text h1 {
    font-size: 32px;  
    line-height: 40px;
    font-weight: 600; 
}

.easycommerce-ask-ai-generate-text h2 {
    font-size: 28px;
    line-height: 36px;
    font-weight: 600;
}

.easycommerce-ask-ai-generate-text h3 {
    font-size: 24px; 
    line-height: 36px;
    font-weight: 500;
}

.easycommerce-ask-ai-generate-text h4 {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
}

.easycommerce-ask-ai-generate-text h5 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
}

.scrollbar-hide {
  -ms-overflow-style: none;  
  scrollbar-width: none;    
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;            
}

/* Thin standard scrollbar */
.thin-scrollbar {
  scrollbar-width: thin;            /* Firefox */
  scrollbar-color: #cbd5e1 transparent;
}

/* Chrome, Edge, Safari */
.thin-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.thin-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.thin-scrollbar::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 9999px;
}

.thin-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/common/components/AISearchButton/aisearch.css"],"names":[],"mappings":"AAAA;CACC;EACC,wBAAwB;EACxB,aAAa;CACd;CACA;EACC,2BAA2B;EAC3B,UAAU;CACX;CACA;EACC,wBAAwB;EACxB,aAAa;CACd;AACD;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,kCAAkC;AACnC;;AAEA;CACC,6BAA6B;CAC7B;;;;;;;gBAOe;AAChB;;AAEA;;CAEC,oBAAoB;AACrB;;AAEA;;CAEC,eAAe;CACf,iBAAiB;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB,aAAa,YAAY;EAC9C,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@keyframes ec-typing {\n\t0% {\n\t\ttransform: translateY(0);\n\t\topacity: 0.35;\n\t}\n\t50% {\n\t\ttransform: translateY(-6px);\n\t\topacity: 1;\n\t}\n\t100% {\n\t\ttransform: translateY(0);\n\t\topacity: 0.35;\n\t}\n}\n\n.typing-dot {\n\tbackground: #7351fd;\n\topacity: 0.35;\n\tanimation: ec-typing 0.9s infinite;\n}  \n\n.ai-search-btn {\n\tborder: 2px solid transparent;\n\tbackground:\n    linear-gradient(#fff, #fff) padding-box,\n    linear-gradient(\n      96.62deg,\n      #A451FD 4.25%,\n      #2977D1 31.45%,\n      #FE0098 100.67%\n    ) border-box;\n}\n\n.easycommerce-ask-ai-generate-text p,\n.easycommerce-ask-ai-generate-text h3 {\n\tpadding-bottom: 15px;\n}\n\n.easycommerce-ask-ai-generate-text div,\n.easycommerce-ask-ai-generate-text p {\n\tfont-size: 14px;\n\tline-height: 24px;\n}\n\n.easycommerce-ask-ai-generate-text h1 {\n    font-size: 32px;  \n    line-height: 40px;\n    font-weight: 600; \n}\n\n.easycommerce-ask-ai-generate-text h2 {\n    font-size: 28px;\n    line-height: 36px;\n    font-weight: 600;\n}\n\n.easycommerce-ask-ai-generate-text h3 {\n    font-size: 24px; \n    line-height: 36px;\n    font-weight: 500;\n}\n\n.easycommerce-ask-ai-generate-text h4 {\n    font-size: 20px;\n    line-height: 28px;\n    font-weight: 500;\n}\n\n.easycommerce-ask-ai-generate-text h5 {\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 500;\n}\n\n.scrollbar-hide {\n  -ms-overflow-style: none;  \n  scrollbar-width: none;    \n}\n\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;            \n}\n\n/* Thin standard scrollbar */\n.thin-scrollbar {\n  scrollbar-width: thin;            /* Firefox */\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n/* Chrome, Edge, Safari */\n.thin-scrollbar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.thin-scrollbar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.thin-scrollbar::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1;\n  border-radius: 9999px;\n}\n\n.thin-scrollbar::-webkit-scrollbar-thumb:hover {\n  background-color: #94a3b8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
